import React from 'react'
import { Button } from '@mui/material'
import { ChevronLeftSolid, ChevronRightSolid } from '@convious/icons'
import { DatePicker } from 'uiComponents/popups/datePickerInput'
import { FormItem } from 'uiComponents/form/formElements'

interface DateControlsProps {
    selectedDate: Date
    handleDateChange: (date: Date) => void
    stepDate: (step: 'increment' | 'decrement') => () => void
    ordersCount: number
}

export const DateControls: React.FC<DateControlsProps> = ({
    selectedDate,
    handleDateChange,
    stepDate,
    ordersCount,
}) => {
    return (
        <div className="date-picker-container">
            <FormItem className="date-picker" htmlFor="validFrom">
                <DatePicker
                    id="selectedDate"
                    date={selectedDate ? new Date(selectedDate) : null}
                    onChange={handleDateChange}
                />
            </FormItem>
            <div className="day-step-button-container">
                <Button
                    className="day-step-button"
                    variant="outlined"
                    color="secondary"
                    size="small"
                    onClick={stepDate('decrement')}
                >
                    <ChevronLeftSolid />
                </Button>
                <Button
                    variant="outlined"
                    color="secondary"
                    size="medium"
                    onClick={() => handleDateChange(new Date())}
                    className="control-button"
                >
                    Today
                </Button>
                <Button
                    className="day-step-button"
                    variant="outlined"
                    color="secondary"
                    size="small"
                    onClick={stepDate('increment')}
                >
                    <ChevronRightSolid />
                </Button>
            </div>
            <div className="order-count">
                <strong>{ordersCount} orders</strong> on this date
            </div>
        </div>
    )
}
